module.exports = __webpack_public_path__ + "img/img-redline.2abfce84.png";